import { Component, Type, ViewChild } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";

import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";

import { ColumnBase } from "@progress/kendo-angular-grid";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherDetailCommentComponent } from "src/app/backoffice/acc/acc-voucher-detail-comment/acc-voucher-detail-comment.component";
import { TrsVoucherKind } from "../../models/trs-voucher-kind.model";
import { TrsVoucherKindFormComponent } from "../trs-voucher-kind-form/trs-voucher-kind-form.component";
import { TrsVoucherKindImportExportFormComponent } from "../trs-voucher-kind-import-export/trs-voucher-kind-import-export-form.component";

@Component({
  selector: "ngx-trs-voucher-kind-list",
  templateUrl: "./trs-voucher-kind-list.component.html",
  styleUrls: ["./trs-voucher-kind-list.component.scss"],
})
export class TrsVoucherKindListComponent extends BaseListComponent {
  actions: EntityListAction[];
  @ViewChild("grid") grid: KGridComponent;
  constructor(public dialogService: SimpleModalService) {
    super();
    this.inputEditorform = TrsVoucherKindFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.apiName = "TrsVoucherKind";
    this.areaName = "Treasury";
    this.label = "انواع سند";
    this.setactions();
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: TrsVoucherKind,
    onRowsSelected: TrsVoucherKind[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    if (action.name === "AccVoucherDetailComment") {
      if (!onRowSelected || !onRowSelected.HasJournalVoucher) {
        this.sts.showDialog("هیچ نوع سندی انتخاب نشده یا با سیستم حسابداری مرتبط نیست", "خطا");
        return;
      }
      let accVoucherDetailComment: Type<any> = AccVoucherDetailCommentComponent;
      this.dialogService
        .open(
          accVoucherDetailComment,
          {
            VoucherKindTitle: onRowSelected.Title,
            TrsVoucherKindId: onRowSelected.Id,
          },
          {
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {});
    }
    if (action.name === "ImportFromExcel" || action.name === "ImportExport") {
      var gridInfo = this.getGridInfo(this.grid.grid.columns.toArray());
      this.dialogService
        .open(
          action.Form_Component,
          {
            gridInfo: gridInfo,
            label: action.displayName,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {});
    }
    return;
  }
  setactions() {
    this.actions = [
      {
        name: "AccVoucherDetailComment",
        disabled: false,
        displayName: "قالب شرح سند حسابداری",
        iconName: "icon-format_list_numbered_rtl-o",
        apiName: "AccVoucherDetailComment",
        areaName: "Accounting",
        permission: Permission.managePermission,
      },
      {
        name: "ImportExport",
        disabled: false,
        displayName: "استخراج و دریافت",
        iconName: "icon-import_export-o",
        apiName: "TrsVoucherKind/ImportExport",
        areaName: "Treasury",
        Form_Component: TrsVoucherKindImportExportFormComponent,
        permission: Permission.samePermission,
      },
    ];
  }
  getGridInfo(columns: ColumnBase[]): GridColumnInfoDetail[] {
    return columns
      .filter((x) => !x.hidden)
      .map((x) => {
        const info = new GridColumnInfoDetail();
        info.name = x["field"];
        info.hidden = x.hidden;
        info.orderindex = x.orderIndex;
        info.title = x.title;
        return info;
      });
  }
}
